import { useContext } from "react";

import { ViewMode, ViewModeContext } from "@/shared/contexts/viewModeContext";

export const useViewMode = (): { viewMode: ViewMode } => {
    const { viewMode } = useContext(ViewModeContext);
    return {
        viewMode,
    };
};
